import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/shared/state/store';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import axios interceptor for automatic Bearer token handling
import './shared/services/axios.interceptor';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from 'click-outside-vue3';
import VueApexCharts from 'vue3-apexcharts';
import { vMaska } from 'maska';

import VueFeather from 'vue-feather';

import '@/assets/scss/config/default/app.scss';
import 'leaflet/dist/leaflet.css';
import '@/assets/scss/mermaid.min.css';
import '@/assets/scss/pages/auth-shared.scss';
import '@/assets/scss/pages/auth-forms.scss';
import '@/assets/scss/pages/list-page.scss';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000,
});

createApp(App)
  .use(store)
  .use(router)
  .use(store)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .component(VueFeather.type, VueFeather)
  .directive('maska', vMaska)
  .use(VueSweetalert2)
  .use(vClickOutside)
  .mount('#app');
